import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSc = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="flag-icons-sc"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="#fff" d="M0 0h640v480H0Z" />
    <path fill="#d92223" d="M0 480V0h640v160z" />
    <path fill="#fcd955" d="M0 480V0h426.7z" />
    <path fill="#003d88" d="M0 480V0h213.3z" />
    <path fill="#007a39" d="m0 480 640-160v160z" />
  </svg>
);
export default SvgSc;
